import { useState } from "react";

export default function useSpinner() {
  const [isShown, setIsShown] = useState(false);

  const show = () => {
    setIsShown(true);
  };

  const hide = () => {
    setIsShown(false);
  };

  return {
    isShown,
    show,
    hide
  };
}
